import { SHIPMENT_SCOPE, SHIPMENT_TYPE } from "../util/constants"

const dsrstatic_cn=
{
    "container_number":"Container Number(s)",
    "container_types":"Container Types",
    "empty_container_pickup":"Empty Container Pick-up",
    "wtPerContainer":"Weight Per Container",
    "customsSealUpdated":"Customs Seal Updated",
    "numContainers":"Number of Containers",
    "unit":"Unit",
    "containerType":"Container Types",
    "agentSealUpdated":"Agent Seal Updated",
        "container_arrival_factory":"Empty Container Arrival @ Factory",
        "loaded_and_dispatch":"Loaded & Dispatched",
        "container_handover":"Container Handover @ POR",
        "por_to_pol_movement":"Rail-out / Truck-out Status",
        "gatein_pol":"Gate-in @ POL",
        "gateout_to_fpod":"ATD from POD",
        "gatein_fpod":"ATA @ FPOD",
        "container_pickup_fpod":"Container Pick-up @ FPOD",
        "estimate_delivery_date_to_consignee":"Estimated Delivery Date to Consignee",
        "container_delivery":"Container Delivered to Consignee",
        "empty_return":"Empty Container Return to Carrier",
        "empty_container_arrival_at_por":"Container Arrival @ Origin CFS",
        "stuffing_confirmation":"CFS Stuffing Date",
        "container_arrival_at_fpod":"Container Arrival @ Destination CFS",
        "container_de_vanning":"Container De-vanning",
        "agentSeal":"Agent Seal Number",
        "customsSeal":"Custom Seal Number"
}


const dsrstatic_FCLFactoryFactory={
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
'company': "Customer" ,
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference #`,
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"mlo":"Mainline Operator",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
'cargo_gatein_CFS': 'Cargo Gate-in at CFS',
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"delivery_order_status":"DO Not Released to Consignee",
"do_remarks":"Delivery Order Remarks",
"pod_terminal_name":"POD Terminal Name",
"pod_terminal_operator_code":"POD Terminal Operator Code",
"terminal_dwell_days":"Terminal Dwell Days @ POD",
"demurrage_free_time_days":"Demurrage Free Time (Days)",
"detention_free_days":"Detention Free Time (Days)",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLFactoryFactory_keys=[
"shipper_name",
"branch_name",
"consignee_name",
'company',
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"destination2",
"destination3",
"destination4",
"destination5",
"por",
"pol",
"pod",
"fpod",
"mlo",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
"shipping_instructions_cut_off",
'shipbill_cutoff',
'container_gate_cut_off',
'gate_opening',
'ams_cutoff',
'isf_cutoff',
"gate_cut_off",
"empty_container_pickup",
"container_arrival_factory",
"loaded_and_dispatch",
"container_number",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'cargo_gatein_CFS',
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"delivery_order_status",
"do_remarks",
"container_pickup_fpod",
"estimate_delivery_date_to_consignee",
"container_delivery",
"pod_terminal_name",
"pod_terminal_operator_code",
"terminal_dwell_days",
"demurrage_free_time_days",
"detention_free_days",
"agentSeal",
"customsSeal",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"vdes2",
"vdes3",
"vdes4",
"vdes5",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d",
"total_package",
"ltlversion",
"carting"
]


const dsrstatic_FCLDockFactory =
{
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name", 
'company': "Customer" ,
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference #`,
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"mlo":"Mainline Operator",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
"cargo_gatein_CFS": 'Cargo Gate-in at CFS',
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"delivery_order_status":"DO Not Released to Consignee",
"do_remarks":"Delivery Order Remarks",
"pod_terminal_name":"POD Terminal Name",
"pod_terminal_operator_code":"POD Terminal Operator Code",
"terminal_dwell_days":"Terminal Dwell Days @ POD",
"demurrage_free_time_days":"Demurrage Free Time (Days)",
"detention_free_days":"Detention Free Time (Days)",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLDockFactory_keys = [ 
"shipper_name",
"branch_name",
"consignee_name",
'company',
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"destination2",
"destination3",
"destination4",
"destination5",
"por",
"pol",
"pod",
"fpod",
"mlo",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
"shipping_instructions_cut_off",
'shipbill_cutoff',
'container_gate_cut_off',
'gate_opening',
'ams_cutoff',
'isf_cutoff',
"gate_cut_off",
"empty_container_pickup",
"empty_container_arrival_at_por",
"container_number",
"stuffing_confirmation",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'cargo_gatein_CFS',
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"delivery_order_status",
"do_remarks",
"container_pickup_fpod",
"estimate_delivery_date_to_consignee",
"container_delivery",
"pod_terminal_name",
"pod_terminal_operator_code",
"terminal_dwell_days",
"demurrage_free_time_days",
"detention_free_days",
"agentSeal",
"customsSeal",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"vdes2",
"vdes3",
"vdes4",
"vdes5",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d",
"total_package",
"ltlversion",
"carting"
]


const dsrstatic_FCLFactoryDock = {
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
'company': "Customer" ,
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference #`,
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"mlo":"Mainline Operator",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"shipping_instructions_cut_off":"SI Cut-off",
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
'cargo_gatein_CFS': 'Cargo Gate-in at CFS',
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"delivery_order_status":"DO Not Released to Consignee",
"do_remarks":"Delivery Order Remarks",
"pod_terminal_name":"POD Terminal Name",
"pod_terminal_operator_code":"POD Terminal Operator Code",
"terminal_dwell_days":"Terminal Dwell Days @ POD",
"demurrage_free_time_days":"Demurrage Free Time (Days)",
"detention_free_days":"Detention Free Time (Days)",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLFactoryDock_keys = [
"shipper_name",
"branch_name",
"consignee_name",
'company',
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"destination2",
"destination3",
"destination4",
"destination5",
"por",
"pol",
"pod",
"fpod",
"mlo",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
"shipping_instructions_cut_off",
// "shipping_instructions_cut_off",
'shipbill_cutoff',
'container_gate_cut_off',
'gate_opening',
'ams_cutoff',
'isf_cutoff',
"gate_cut_off",
"empty_container_pickup",
"container_arrival_factory",
"loaded_and_dispatch",
"container_number",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'cargo_gatein_CFS',
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"delivery_order_status",
"do_remarks",
"container_pickup_fpod",
"container_arrival_at_fpod",
"container_de_vanning",
"pod_terminal_name",
"pod_terminal_operator_code",
"terminal_dwell_days",
"demurrage_free_time_days",
"detention_free_days",
"agentSeal",
"customsSeal",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"vdes2",
"vdes3",
"vdes4",
"vdes5",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d",
"total_package",
"ltlversion",
"carting"
]

const dsrstatic_FCLDockDock = {
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name", 
'company': "Customer",
"cust_ref_number":"Customer Reference #",
"agraga_booking_#":`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference #`,
"origin":"Origin",
"destination":"Destination",
"por":"Place of Receipt",
"pol":"Port of Loading",
"pod":"Port of Discharge",
"fpod":"Final Place of Delivery",
"mlo":"Mainline Operator",
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"gate_cut_off":"Gate Cut off",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
"cargo_gatein_CFS": "Cargo Gate-in at CFS",
"etd_at_pol":"ETD @ POL",
"sob_pol":"Shipped-on-Board",
"hbl_number":"HBL #",
"mbl_number":"MBL #",
"arrival_notice":"Arrival Notice to Consignee",
"eta_fpod":"ETA @ FPOD",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"delivery_order_status":"DO Not Released to Consignee",
"do_remarks":"Delivery Order Remarks",
"pod_terminal_name":"POD Terminal Name",
"pod_terminal_operator_code":"POD Terminal Operator Code",
"terminal_dwell_days":"Terminal Dwell Days @ POD",
"demurrage_free_time_days":"Demurrage Free Time (Days)",
"detention_free_days":"Detention Free Time (Days)",
"remarks":"Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_FCLDockDock_keys = [
"shipper_name",
"branch_name",
"consignee_name",
'company',
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"destination2",
"destination3",
"destination4",
"destination5",
"por",
"pol",
"pod",
"fpod",
"mlo",
"carrier_booking_ref_number",
"carrier_booking_release",
"vgm_cut_off",
// "shipping_instructions_cut_off",
"shipping_instructions_cut_off",
'shipbill_cutoff',
'container_gate_cut_off',
'gate_opening',
'ams_cutoff',
'isf_cutoff',
"gate_cut_off",
"empty_container_pickup",
"empty_container_arrival_at_por",
"container_number",
"stuffing_confirmation",
"container_handover",
"por_to_pol_movement",
"gatein_pol",
"fl_vessel_name",
"fl_vessel_number",
'cargo_gatein_CFS',
'etd_at_pol',
"sob_pol",
"hbl_number",
"mbl_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
"arrival_notice",
'eta_at_pod',
"pod_arrival",
"etd_pod",
"gateout_to_fpod",
"eta_fpod",
"gatein_fpod",
"last_free_date_at_fpod",
"delivery_order_release",
"delivery_order_status",
"do_remarks",
"container_pickup_fpod",
"container_arrival_at_fpod",
"container_de_vanning",
"pod_terminal_name",
"pod_terminal_operator_code",
"terminal_dwell_days",
"demurrage_free_time_days",
"detention_free_days",
"agentSeal",
"customsSeal",
"remarks",
"status_closed",
"containerlist",
"vorgin",
"vdes",
"vdes2",
"vdes3",
"vdes4",
"vdes5",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d",
"total_package",
"ltlversion",
"carting"
]

const dsrstatic_LCL ={
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
'company': "Customer" ,
'cust_ref_number':'Customer Reference #',
'agraga_booking_#':`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference #`,
'origin':'Origin',
'destination':'Destination',
'carrier':'Carrier',
'cargo_gatein_CFS':'Cargo Gate-in at CFS',
'stuffing_confirmation':'Stuffing Confirmation',
'cargo_cutoff':'Cargo Cut-Off',
'leo_cutoff':'LEO Cut-Off',
'stuffing_cutoff': 'Stuffing Cut-Off',
'por':'Place of Receipt',
'pol':'Port of Loading',
"gatein_pol":"Gate-in at POL",
"fl_vessel_name":"1st Leg Vessel Name",
"fl_vessel_number":"1st Leg Voyage #",
'pol_container_number':'POL Container #',
'containerType':'Container Type',
'hbl_number': `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} HBL Number`,
'mbl_number':'MBL Number',
"etd_at_pol":"ETD @ POL",
'sob_pol':'Shipped-on-Board',
'new_carrier_name':'New Carrier Name',
'new_carrier_mbl_number':'New Carrier MBL Number',
'reworkingPort': 'Reworking Port',
'pod':'Port of Discharge (POD)',
'fpod':'Final Place of Delivery (FPOD)',
'eta_fpod':'ETA @ FPOD',
'gatein_fpod':'ATA @ FPOD',
'destuffing_fpod':'De-stuffing Status @ fpod',
"last_free_date_at_fpod":"Last Free Date @ FPOD",
'arrival_notice':'Arrival Notice to Consignee',
'delivery_order_release':'Delivery Order Release to Consignee',
"delivery_order_status":"DO Not Released to Consignee",
"do_remarks":"Delivery Order Remarks",
"consolidator":"Consolidator",
'remarks':'Special Remarks',      
"agentSeal":"Agent Seal Number",
"customsSeal":"Custom Seal Number",
"container_discharged_pod": "Container Discharged @ POD",
"container_arrived_cfs": "Container Arrived @ Destination CFS",
"terminal_drayage_out": "Container Picked-up from Terminal (Drayage Out)",
"loaded_for_inland": "Loaded on Rail/Truck for Inland Transit",
"cargo_available_at_cfs": "Cargo Available @ Destination CFS",
"fpod_customs_release": "Custom Release",
"destination_freight_release": "Freight Release",
"inbond_number": "In-Bond Number (CBP 7512 IT)",
"destination_cfs_name": "Destination CFS Warehouse Name",
"destination_cfs_address": "Destination CFS Street Address",
"cfs_firm_code": "US Customs FIRMS Code",
"verified_pieces": "Verified Pieces Count",
"verified_package_type": "Package Type",
"verified_weight_kg": "Verified Gross Weight (kg)",
"verified_volume_cbm": "Verified Volume (CBM)",
"go_date_fpod": "General Order (G.O.) Date @ FPOD",
"pod_terminal_name":"POD Terminal Name",
"pod_terminal_operator_code":"POD Terminal Operator Code",
"terminal_dwell_days":"Terminal Dwell Days @ POD",
"demurrage_free_time_days":"Demurrage Free Time (Days)",
"detention_free_days":"Detention Free Time (Days)",
"status_closed": "Is the Booking Closed?"
}

const dsrstatic_LCL_keys=[

'shipper_name',
'branch_name',
'consignee_name',
'company',
'cust_ref_number',
'agraga_booking_#',
'origin',
'destination',
"destination2",
"destination3",
"destination4",
"destination5",
"por",
"pol",
'reworkingPort',
"pod",
"fpod",
'carrier',
"consolidator",
'cargo_cutoff',
'leo_cutoff',
'stuffing_cutoff',
'cargo_gatein_CFS',
'stuffing_confirmation' ,
'pol_container_number',
'containerType',
'container_handover' ,
'por_to_pol_movement' ,
'pol_arrival' ,
'rail_yard_to_cfs' ,
'destuffing_at_pol' ,
'restuffing_at_pol' ,
'gatein_pol' ,
'hbl_number',
'coloader_hbl_number',
'mbl_number',
"fl_vessel_name",
"fl_vessel_number",
'etd_at_pol' ,
'sob_pol' ,
'reworking_pol_port',
'reworking_pol_arrival_estimate',
                        "reworking_pol_arrival",
                        'reworking_pol_departure_estimate',
                        "reworking_pol_departure",
                        "reworking_pol_vessel_name",
                         "reworking_pol_vessel_number",
                         'reworking_pol_destuffing',
                        "reworking_pol_restuffing",
                        "reworking_pol_container_number",
"ts1_port",
'ts1_arrival_estimate',
"ts1_arrival",
'ts1_departure_estimate',
"ts1_departure",
"ts1_vessel_name",
"ts1_vessel_number",
"ts2_port",
'ts2_arrival_estimate',
"ts2_arrival",
'ts2_departure_estimate',
"ts2_departure",
"ts2_vessel_name",
"ts2_vessel_number",
"ts3_port",
'ts3_arrival_estimate',
"ts3_arrival",
'ts3_departure_estimate',
"ts3_departure",
"ts3_vessel_name",
"ts3_vessel_number",
"ts4_port",
'ts4_arrival_estimate',
"ts4_arrival",
'ts4_departure_estimate',
"ts4_departure",
"ts4_vessel_name",
"ts4_vessel_number",
'reworking_pod_port',
'reworking_pod_arrival_estimate',
"reworking_pod_arrival",
'reworking_pod_departure_estimate',
"reworking_pod_departure",
 "reworking_pod_vessel_name",
 "reworking_pod_vessel_number",
'reworking_pod_destuffing',
"reworking_pod_restuffing",
"reworking_pod_container_number",
'new_carrier_name',
'new_carrier_mbl_number',
'reworking_container_number',
'reworking_departure_estimate' ,
'sob_reworking' ,
'reworking_departure_actual' ,
'eta_at_pod' ,
'pod_arrival' ,
'container_discharged_pod',
'pod_terminal_name',
'pod_terminal_operator_code',
'terminal_dwell_days',
'demurrage_free_time_days',
'detention_free_days',
'terminal_drayage_out',
'etd_pod' ,
'gateout_to_fpod' ,
'loaded_for_inland',
'inbond_number',
'eta_fpod' ,
'gatein_fpod' ,
'container_arrived_cfs',
'destuffing_fpod' ,
'cargo_available_at_cfs',
'arrival_notice' ,
'fpod_customs_release',
'destination_freight_release',
'last_free_date_at_fpod' ,
'delivery_order_release' ,
"delivery_order_status",
"do_remarks",
'cargo_picked_up_by_consignee',
'go_date_fpod',
'destination_cfs_name',
'destination_cfs_address',
'cfs_firm_code',
'verified_pieces',
'verified_package_type',
'verified_weight_kg',
'verified_volume_cbm',
'remarks',
"agentSeal",
"customsSeal",
"status_closed",
"vorgin",
"vdes",
"vdes2",
"vdes3",
"vdes4",
"vdes5",
"reworking_at_pol",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"project44_1d",
"total_package",
"ltlversion",
"carting",
]


const dsrstatic_Air ={
"shipper_name":"Shipper Name",
"branch_name":"Branch Name",
"consignee_name":"Consignee Name",
'company': 'Customer',
"cust_ref_number": "Customer Reference #",
"agraga_booking_#": `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference #`,
"origin": "Origin",
"destination": "Destination",
"departure_airport": "Airport of Departure",
"arrival_airport":"Airport of Arrival",
"carrier": "Airline",
"airline_booking_release": "Airline Release Order",
"airline_booking_ref_number": "Airline Booking Reference #",
'arrival_dispatch_airport':'Gate-in at Cargo Terminal',
"etd_airport_of_departure":"ETD Airport of Departure",
"loaded_on_board": "Loaded-on-Board",
"flight_number_departure_airport":"Flight Number from Departure Airport",
"hawb_number": "HAWB Number",
"mawb_number": "MAWB Number",
"ts1_airport": "Transhipment 1 Airport (if any)",
"ts1_arrival_estimate":"ETA Transhipment 1",
"ts1_arrival":"ATA Transhipment 1",
"flight_number_ts1": "Flight Number from Transhipment 1 Airport",
"ts1_departure_estimate":"ETD Transhipment 1",
"ts1_departure":"ATD Transhipment 1",
"ts2_airport": "Transhipment 2 Airport (if any)",
"ts2_arrival_estimate":"ETA Transhipment 2",
"ts2_arrival":"ATA Transhipment 2",
"flight_number_ts2": "Flight Number from Transhipment 2 Airport",
"ts2_departure_estimate":"ETD Transhipment 2",
"ts2_departure":"ATD Transhipment 2",
"ts3_airport": "Transhipment 3 Airport (if any)",
"ts3_arrival_estimate":"ETA Transhipment 3",
"ts3_arrival":"ATA Transhipment 3",
"flight_number_ts3": "Flight Number from Transhipment 3 Airport",
"ts3_departure_estimate":"ETD Transhipment 3",
"ts3_departure":"ATD Transhipment 3",
"ts4_airport": "Transhipment 4 Airport (if any)",
"ts4_arrival_estimate":"ETA Transhipment 4",
"ts4_arrival":"ATA Transhipment 4",
"flight_number_ts4": "Flight Number from Transhipment 4 Airport",
"ts4_departure_estimate":"ETD Transhipment 4",
"ts4_departure":"ATD Transhipment 4",
"eta_at_arrival_airport":"ETA @ Arrival Airport",
"ata_at_arrival_airport":"ATA @ Arrival Airport",
"arrival_notice": "Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release": "Delivery Order Released to Consignee",
"remarks": "Special Remarks",
"status_closed": "Is the Booking Closed?",
}


const dsrstatic_Air_keys = [
"shipper_name",
"branch_name",
"consignee_name",
'company',
"cust_ref_number",
"agraga_booking_#",
"origin",
"destination",
"destination2",
"destination3",
"destination4",
"destination5",
"departure_airport",
"arrival_airport",
"carrier",
"airline_booking_release",
"airline_booking_ref_number",
'arrival_dispatch_airport',
"etd_airport_of_departure",
"loaded_on_board",
"flight_number_departure_airport",
"hawb_number",
"mawb_number",
"ts1_airport",
"ts1_arrival_estimate",
"ts1_arrival",
"flight_number_ts1",
"ts1_departure_estimate",
"ts1_departure",
"ts2_airport",
"ts2_arrival_estimate",
"ts2_arrival",
"flight_number_ts2",
"ts2_departure_estimate",
"ts2_departure",
"ts3_airport",
"ts3_arrival_estimate",
"ts3_arrival",
"flight_number_ts3",
"ts3_departure_estimate",
"ts3_departure",
"ts4_airport",
"ts4_arrival_estimate",
"ts4_arrival",
"flight_number_ts4",
"ts4_departure_estimate",
"ts4_departure",
"eta_at_arrival_airport",
"ata_at_arrival_airport",
"arrival_notice",
"last_free_date_at_fpod",
"delivery_order_release",
"remarks",
"status_closed",
"vorgin",
"vdes",
"vdes2",
"vdes3",
"vdes4",
"vdes5",
"_id",
"tsUpdatedOn",
"tsUpdatedBy",
"total_package",
"ltlversion",
"carting"
]

const dsrstatic_FactoryFactoryViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
"gate_cut_off":"Gate Cut off",
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"hbl_number":"HBL #",
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
}

const dsrstatic_DockFactoryViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
"gate_cut_off":"Gate Cut off",
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"stuffing_confirmation":"Stuffing Confirmation",
"hbl_number":"HBL #",
"cargo_gatein_CFS": 'Cargo Gate-in at CFS',
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
}

const dsrstatic_FactoryDockViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
"gate_cut_off":"Gate Cut off",
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"hbl_number":"HBL #",
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
}

const dsrstatic_DockDockViewDetailsKeys = {
"carrier_booking_ref_number":"Carrier Booking Reference #",
"carrier_booking_release":"Carrier Release Order",
"vgm_cut_off":"VGM Cut off",
"shipping_instructions_cut_off":"SI Cut-off",
'shipbill_cutoff': 'Shipping Bill Cut-off',
'container_gate_cut_off':'Container Gate Cut-off',
'gate_opening': 'Gate Opening',
"gate_cut_off":"Gate Cut off",
'ams_cutoff':'AMS Cut-Off',
'isf_cutoff':'ISF Cut-off',
"hbl_number":"HBL #",
"cargo_gatein_CFS": 'Cargo Gate-in at CFS',
"arrival_notice":"Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release":"Delivery Order Release",
"remarks":"Special Remarks",
} 

const dsrstatic_AirViewDetailsKeys={
"carrier": "Airline",
"airline_booking_release": "Airline Release Order",
"airline_booking_ref_number": "Airline Booking Reference #",
"flight_number_departure_airport":"Flight Number from Departure Airport",
"hawb_number": "HAWB Number",
"mawb_number": "MAWB Number",
"flight_number_ts1": "Flight Number from Transhipment 1 Airport",
"flight_number_ts2": "Flight Number from Transhipment 2 Airport",
'arrival_dispatch_airport':'Gate-in at Cargo Terminal',
"arrival_notice": "Arrival Notice to Consignee",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
"delivery_order_release": "Delivery Order Released to Consignee",
"remarks": "Special Remarks",
}

const dsrstatic_LCLViewDetailsKeys={
'carrier':'Carrier',
'stuffing_confirmation':'Stuffing Confirmation',
"destuffing_at_pol":"De-stuffing Status",
"restuffing_at_pol":"Re-stuffing Status",
"pol_container_number":"POL Container #",
'containerType' : "Container Type",
'hbl_number': `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} HBL Number`,
'coloader_hbl_number': 'Coloader HBL Number',
'mbl_number':'MBL Number',
"cargo_gatein_CFS": 'Cargo Gate-in at CFS',
"destuffing_reworking":"De-stuffing @ Re-working Port",
"restuffing_reworking":"Re-stuffing @ Re-working Port",
'new_carrier_name':'New Carrier Name',
'stuffing_cutoff': 'Stuffing Cut-Off',
'cargo_cutoff':'Cargo Cut-Off',
'leo_cutoff':'LEO Cut-Off',
'new_carrier_mbl_number':'New Carrier MBL Number',
"reworking_container_number":"Re-working Container #",
"destuffing_fpod":"De-stuffing Status @ fpod",
"last_free_date_at_fpod":"Last Free Date @ FPOD",
'arrival_notice':'Arrival Notice to Consignee',
'delivery_order_release':'Delivery Order Release to Consignee',
"container_discharged_pod": "Container Discharged @ POD",
"container_arrived_cfs": "Container Arrived @ Destination CFS",
"terminal_drayage_out": "Container Picked-up from Terminal (Drayage Out)",
"loaded_for_inland": "Loaded on Rail/Truck for Inland Transit",
"cargo_available_at_cfs": "Cargo Available @ Destination CFS",
"fpod_customs_release": "Custom Release",
"destination_freight_release": "Freight Release",
"inbond_number": "In-Bond Number (CBP 7512 IT)",
"destination_cfs_name": "Destination CFS Warehouse Name",
"destination_cfs_address": "Destination CFS Street Address",
"cfs_firm_code": "US Customs FIRMS Code",
"verified_pieces": "Verified Pieces Count",
"verified_package_type": "Package Type",
"verified_weight_kg": "Verified Gross Weight (kg)",
"verified_volume_cbm": "Verified Volume (CBM)",
"go_date_fpod": "General Order (G.O.) Date @ FPOD",
"pod_terminal_name": "POD Terminal Name",
"pod_terminal_operator_code": "POD Terminal Operator Code",
"terminal_dwell_days": "Terminal Dwell Days @ POD",
"demurrage_free_time_days": "Demurrage Free Time (Days)",
"detention_free_days": "Detention Free Time (Days)",
'remarks':'Special Remarks',    
}

const originVehicleKeys = {
    "vehicle": "Vehicle#",
    "arrival_factory": "Arrival @ Factory",
    "cargo_pickup": "Cargo Pickup",
    "cargo_arrival_cfs": "Cargo arrival at CFS"
}

const destinationVehicleKey = {
    "vehicle": "Vehicle#",
    "container_number_vehicle":"Container Number",
    "number_of_package":"Number Of Package",
    "loaded_cfs": "Loaded @ CFS",
    "atdfrompod": "Cargo Picked-up for Delivery",
    "estimate_delivery_date_to_consignee": "Estimated Delivery Date to Consignee",
    "actual_delivery_date": "Actual Delivery Date"
}
const CoiCreationKey = {
    "personalDetails":"PersonalDetails",
    "entityName": "Business Name",
    "commodityType":"Sub Commodity",
    "lastName":"Last Name",
    "packageType": "Description Of Packaging",
    "phoneNo":"Phone No",
    "transitMode":"Transit Mode",
    "email":"Email",
    "policy_type":"Policy type",
    "gst":"GST Number",
    //"entityCountry":"Party State Name",
    "riskcommencementlocation":'Transit From Country',

    "address":'Address',
    "riskendinglocation":'Transit To Country',
    "city":"City ",

    //"clienttype":"Client Type ",
    "commericalInvoiceValue":"Commercial Invoice Value",
    "state":"State",

    "psd":"Policy Start Date",
    "pincode":"Pincode",

    "journeyDate":"Journey Date",
    "customercontact" :"Contact Person",

    "commericalInvoiceDate":"Invoice Date",
    "descriptionOfCargo":"Description Of Cargo",
    "containerized":"Containerized",
    "containersNo":"Container Number 1",
    "dateofCommencementofVoyage":"Date of Commencement of Voyage",
    "incoTerms":"Incoterms",
    "commodityType":"Commodity Type"
}

const lclMandatoryFilter = [
  'container_handover', 'gatein_pol'
]

const gatein_mandatory_fields = [
  "por_to_pol_movement",
  "loaded_cfs",
  'dispatched_from_cfs',
  'gatein_pol',
  "rail_yard_to_cfs",
  "destuffing_at_pol",
  "restuffing_at_pol",
  "sob_pol",
  'container_handover',
  "ts1_arrival",
  "ts1_departure",
  "ts2_arrival",
  "ts2_departure",
  "container_pickup_fpod",
  "reworking_pol_destuffing",
  "reworking_pol_restuffing",
  "new_carrier_name",
  "new_carrier_mbl_number",
  "arrival_notice",
  "arrival_factory",
  'arrival_dispatch_airport',
  "cargo_arrival_cfs",
  "pod_arrival",
  "gatein_fpod",
  "destuffing_fpod",
  "last_free_date_at_fpod",
  "gateout_to_fpod",
  "delivery_order_release",
  "cargo_picked_up_by_consignee",
  "atdfrompod",
  "actual_delivery_date",
  "status_closed",
  "reworking_pol_arrival",
  "reworking_pol_container_number",
  "reworking_pol_vessel_name",
  "reworking_pol_departure",
  "reworking_pod_arrival",
  "reworking_pod_destuffing",
  "reworking_pod_restuffing",
  "reworking_pod_container_number",
  "reworking_pod_vessel_name",
  "reworking_pod_departure",
  "reworking_pol_vessel_number",
  "reworking_pod_vessel_number",
  "loaded_on_board",
  "flight_number_departure_airport",
  "flight_number_ts1",
  "ts1_vessel_name",
  "ts1_vessel_number",
  "ts2_vessel_name",
  "ts2_vessel_number",
  "ata_at_arrival_airport",
  "dispatched_from_arrival_airport",
  "container_arrival_factory",
  'container_pickup_at_fpod',
  "container_delivery",
  "empty_container_pickup",
  "container_arrival_at_fpod",
  "container_de_vanning",
  "empty_return",
  "cargo_arrival_cfs",
"ltlversion",
"carting"
]


const origin_pickup_LCL = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    cargo_arrival_cfs: "Cargo arrival at CFS",
  };

  const destination_delivery_LCL = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Cargo Picked-up for Delivery",
    estimate_delivery_date_to_consignee: "Est. Delivery Date to Consignee",
    actual_delivery_date: "Actual delivery date",
  };

  const origin_pickup_AIR = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    arrival_dispatch_airport: "Arrival @ Dispatch Airport",
  };

  const destination_delivery_AIR = {
    dispatched_from_arrival_airport: "Dispatched from Arrival Airport	",
    estimate_delivery_date_to_consignee: "Est. Delivery Date to Consignee",
    actual_delivery_date: "Actual delivery date",
  };

  const origin_pickup_fcl_FACTORY_FACTORY = {
    empty_container_arrival_at_factory: "Empty container arrival at factory",
    loaded_and_dispatched: "loaded and dispatched",
    gate_in_at_pol: "Gate-in @ POL",
    container_number_vehicle: "Container Number"
  };

  const destination_delivery_fcl_FACTORY_FACTORY = {
    container_pickup_at_fpod: "Container pickup @ FPOD",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    container_delivered_to_consignee: "Container delivered to consignee",
    container_number_vehicle: "Container Number"
  };

  const origin_pickup_fcl_FACTORY_CFS = {
    empty_container_arrival_at_factory: "Empty container arrival at factory",
    loaded_and_dispatched: "loaded and dispatched",
    gate_in_at_pol: "Gate-in @ POL",
    container_number_vehicle: "Container Number"
  };

  const destination_delivery_fcl_FACTORY_CFS = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Dispatched from CFS",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    actual_delivery_date: "Actual delivery date",
  };

  const origin_pickup_fcl_CFS_CFS = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    cargo_arrival_cfs: "Cargo arrival at CFS",
  };

  const destination_delivery_fcl_CFS_CFS = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Dispatched from CFS",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    actual_delivery_date: "Actual delivery date",
  };

  const origin_pickup_fcl_CFS_FACTORY = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    cargo_arrival_cfs: "Cargo arrival at CFS",
  };

  const destination_delivery_fcl_CFS_FACTORY = {
    container_pickup_at_fpod: "Container pickup @ FPOD",
    estimate_delivery_date_to_consignee: "Est. delivery date to consignee",
    container_delivered_to_consignee: "Container delivered to consignee",
    container_number_vehicle: "Container Number"
  };

  const getUpdatedFreezeFields = (defaultFields, st, sc, por, pol) => {
    const fieldsToRemove = [];
    let warningMessageForActuals = 'Cargo Pick up / Cargo Gate-in at CFS is required to proceed with Actuals of this shipment'

    if ([SHIPMENT_TYPE.fcl_f_f, SHIPMENT_TYPE.fcl_f_cfs].includes(st)) {
      warningMessageForActuals = 'Gate-in / Container Handover / Loaded & Dispatch is required to proceed with Actuals of this shipment'
        if (por === pol && [SHIPMENT_SCOPE.p2p, SHIPMENT_SCOPE.p2d].includes(sc)) {
            fieldsToRemove.push('gatein_pol');
        } else if (por !== pol && [SHIPMENT_SCOPE.p2p, SHIPMENT_SCOPE.p2d].includes(sc)) {
            fieldsToRemove.push('container_handover');
        } else if ([SHIPMENT_SCOPE.d2p, SHIPMENT_SCOPE.d2d].includes(sc)) {
            fieldsToRemove.push('loaded_and_dispatch');
        }
    }else if([SHIPMENT_TYPE.air].includes(st)) {
      warningMessageForActuals = 'Cargo Pick up / Gate-in at Cargo Terminal is required to proceed with Actuals of this shipment'
      if ( [SHIPMENT_SCOPE.p2p, SHIPMENT_SCOPE.p2d].includes(sc)){
        fieldsToRemove.push('arrival_dispatch_airport');
      }
    }

    return {updatedFreeze:defaultFields.filter(field => !fieldsToRemove.includes(field)), warningMessageForActuals:warningMessageForActuals};
};

const US_IPI_DSR_KEYS = [
  'container_discharged_pod',
  'container_arrived_cfs',
  'terminal_drayage_out',
  'loaded_for_inland',
  'cargo_available_at_cfs',
  'fpod_customs_release',
  'destination_freight_release',
  'inbond_number',
  'ams_number',
  'destination_cfs_name',
  'destination_cfs_address',
  'cfs_firm_code',
  'verified_pieces',
  'verified_package_type',
  'verified_weight_kg',
  'verified_volume_cbm',
  'inbond_submitted_date',
  'inbond_arrived_date',
  'go_date_pod',
  'go_date_fpod'
];

const OCEAN_TRACKING_DSR_KEYS = [
  'pod_terminal_name',
  'pod_terminal_operator_code',
  'terminal_dwell_days',
  'demurrage_free_time_days',
  'detention_free_days'
];

export {
  US_IPI_DSR_KEYS,
  OCEAN_TRACKING_DSR_KEYS,
  gatein_mandatory_fields,
  lclMandatoryFilter,
    dsrstatic_cn,
dsrstatic_FCLFactoryFactory,
dsrstatic_FCLFactoryFactory_keys,
dsrstatic_FCLDockFactory,
dsrstatic_FCLDockFactory_keys,
dsrstatic_FCLFactoryDock,
dsrstatic_FCLFactoryDock_keys,
dsrstatic_FCLDockDock,
dsrstatic_FCLDockDock_keys,
dsrstatic_LCL,
dsrstatic_LCL_keys,
dsrstatic_Air,
dsrstatic_Air_keys,
dsrstatic_FactoryFactoryViewDetailsKeys,
dsrstatic_DockFactoryViewDetailsKeys,
dsrstatic_FactoryDockViewDetailsKeys,
dsrstatic_DockDockViewDetailsKeys,
dsrstatic_AirViewDetailsKeys,
dsrstatic_LCLViewDetailsKeys,
originVehicleKeys,
destinationVehicleKey,
CoiCreationKey,
origin_pickup_LCL,
origin_pickup_fcl_FACTORY_FACTORY,
origin_pickup_fcl_FACTORY_CFS,
origin_pickup_fcl_CFS_FACTORY,
origin_pickup_fcl_CFS_CFS,
origin_pickup_AIR,
destination_delivery_LCL,
destination_delivery_fcl_FACTORY_FACTORY,
destination_delivery_fcl_FACTORY_CFS,
destination_delivery_fcl_CFS_CFS,
destination_delivery_fcl_CFS_FACTORY,
destination_delivery_AIR,
getUpdatedFreezeFields
}